import React from 'react'
import { Toast } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { hideToast } from '../store/toastSlice'

const GlobalToast: React.FC = () => {
	const { show, message, type } = useAppSelector((state) => state.toast)
	const dispatch = useAppDispatch()

	const bgVariant = type === 'error' ? 'danger' : 'info'
	const title = type === 'error' ? 'Помилка' : ''

	return (
		<Toast
			bg={bgVariant}
			className="position-fixed"
			style={{ top: '20px', right: '20px', zIndex: 9999 }}
			onClose={() => dispatch(hideToast())}
			show={show}
			delay={5000}
			autohide
		>
			<Toast.Header>
				<strong className="me-auto">{title}</strong>
			</Toast.Header>
			<Toast.Body>{message}</Toast.Body>
		</Toast>
	)
}

export default GlobalToast


